import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f57bea0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "°", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_badge = _resolveComponent("ion-badge")!

  return ($setup.weatherObj && $setup.weatherObj.weatherType)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass([$props.useDefaultDesign ? 'weather-default' : '', $props.customCss, $props.size, $props.alignIcon, $props.bringToFront ? 'bring-icon-to-front' : '']),
        title: $setup.weatherObj.weatherDescription,
        style: _normalizeStyle($props.customStyle)
      }, [
        _createVNode(_component_ion_icon, {
          icon: $setup.weatherObj.getWeatherIcon(),
          style: _normalizeStyle('color:'+$setup.weatherObj.getWeatherIconColor()),
          class: "weather-icon"
        }, null, 8, ["icon", "style"]),
        ($props.showTemperature && $setup.weatherObj.temperature.measuredTemperature)
          ? (_openBlock(), _createBlock(_component_ion_badge, {
              key: 0,
              class: "temperature-div",
              color: "dark",
              slot: "start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "temperature-text ion-no-padding" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($props.temperatureRoundPrecision > 0 ? $setup.weatherObj.temperature.measuredTemperature.toFixed($props.temperatureRoundPrecision) : Math.round($setup.weatherObj.temperature.measuredTemperature)), 1),
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}